/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EducationProgram } from '../../models/education-program';

export interface UpdateEducationProgram$Params {
  id: string;
      body?: EducationProgram
}

export function updateEducationProgram(http: HttpClient, rootUrl: string, params: UpdateEducationProgram$Params, context?: HttpContext): Observable<StrictHttpResponse<EducationProgram>> {
  const rb = new RequestBuilder(rootUrl, updateEducationProgram.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EducationProgram>;
    })
  );
}

updateEducationProgram.PATH = '/educationprogram/{id}';
